"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsBinding = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var hsPingAnRegister_1 = require("../../model/hsPingAnRegister");
var service_1 = require("../../../library/base/service");
var IsBinding = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(IsBinding, _super);
    function IsBinding() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '判断平安是否绑卡成功(签约)';
        _this.code = '105023';
        _this.desc = '判断平安是否绑卡成功(签约)';
        _this.requestParams = new hsPingAnRegister_1.IsBindingRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return IsBinding;
}(service_1.BaseService));
exports.IsBinding = IsBinding;
//# sourceMappingURL=isBinding.js.map